import { render, staticRenderFns } from "./AmarDashboard.vue?vue&type=template&id=184d925c&scoped=true&"
import script from "./AmarDashboard.vue?vue&type=script&lang=js&"
export * from "./AmarDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AmarDashboard.vue?vue&type=style&index=0&id=184d925c&prod&lang=scss&scoped=true&"
import style1 from "./AmarDashboard.vue?vue&type=style&index=1&id=184d925c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d925c",
  null
  
)

export default component.exports